<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
        <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h2>{{ $route.meta.title }}</h2>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <a href="/home">Home</a>
                            </li>
                            <li class="breadcrumb-item active">
                                {{ $route.meta.title }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>

        <!-- Main content -->
        <section class="content">
            <div class="col-lg-12">
                <div class="row">
                    <div class="col-md-6">
                        <div class="card card-danger card-outline">
                            <div class="card-header">Item Details</div>
                            <div class="card-body">
                                <dl class="row">
                                    <dt class="col-sm-4">Item Name:</dt>
                                    <dd class="col-sm-8">
                                        {{ buyback.item_name }}
                                    </dd>

                                    <dt class="col-sm-4">IMEI:</dt>
                                    <dd class="col-sm-8">
                                        {{ buyback.imei }}
                                    </dd>

                                    <dt class="col-sm-4">Brand:</dt>
                                    <dd class="col-sm-8">
                                        {{ buyback.brand }}
                                    </dd>

                                    <dt class="col-sm-4">Created At:</dt>
                                    <dd class="col-sm-8">
                                        {{ buyback.created_at | timeStamp }}
                                    </dd>

                                    <dt class="col-sm-4">BuyBack Type:</dt>
                                    <dd class="col-sm-8">
                                        {{ buyback.buyback_type }}
                                    </dd>
                                </dl>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="card card-danger card-outline">
                            <div class="card-header">
                                <div class="card-title">Buyback Rule Info</div>
                                <div class="card-tools">
                                    <!-- Collapse Button -->
                                    <button
                                        v-if="buyback.order != null"
                                        class="btn btn-primary"
                                        @click="disposedForPrompt(buyback.id)"
                                    >
                                        <i class="fa fa-edit"></i>
                                        Dispose
                                    </button>
                                </div>
                            </div>
                            <div class="card-body">
                                <dl class="row">
                                    <dt class="col-sm-4">Slab Name:</dt>
                                    <dd class="col-sm-8">
                                        {{ buyback.buyback_rule.slab_name }}
                                    </dd>

                                    <dt class="col-sm-4">Buyback Limit:</dt>
                                    <dd class="col-sm-8">
                                        {{ buyback.buyback_rule.buyback_limit }}
                                    </dd>

                                    <dt class="col-sm-4">Rule Validity:</dt>
                                    <dd class="col-sm-8">
                                        {{ buyback.buyback_rule.validity }}
                                    </dd>

                                    <dt class="col-sm-4">Collected For:</dt>
                                    <dd class="col-sm-8">
                                        {{ buyback.taken_for }}
                                    </dd>

                                    <dt class="col-sm-4">Disposed For:</dt>
                                    <dd class="col-sm-8">
                                        {{ buyback.disposed_for }}
                                    </dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <div class="col-lg-12">
                <div class="row justify-content-center">
                    <div class="col-lg-5">
                        <div class="card card-danger card-outline">
                            <div class="card-header">
                                Images
                                <span class="badge badge-primary ml-2">{{
                                    buyback_images.length
                                }}</span>
                            </div>
                            <div class="card-body">
                                <p>Total Images: {{ buyback_images.length }}</p>
                                <div
                                    id="imageCarousel"
                                    class="carousel slide"
                                    data-ride="carousel"
                                >
                                    <div class="carousel-inner">
                                        <div
                                            v-for="(
                                                image, index
                                            ) in buyback_images"
                                            :key="index"
                                            :class="{
                                                'carousel-item': true,
                                                active: index === 0,
                                            }"
                                        >
                                            <img
                                                class="d-block w-100 img-fluid"
                                                :src="image.url"
                                                alt="Buyback image"
                                                @click="openImageModal(index)"
                                            />
                                        </div>
                                    </div>
                                    <a
                                        class="carousel-control-prev"
                                        href="#imageCarousel"
                                        role="button"
                                        data-slide="prev"
                                    >
                                        <span
                                            class="carousel-control-prev-icon"
                                            aria-hidden="true"
                                        ></span>
                                        <span class="sr-only">Previous</span>
                                    </a>
                                    <a
                                        class="carousel-control-next"
                                        href="#imageCarousel"
                                        role="button"
                                        data-slide="next"
                                    >
                                        <span
                                            class="carousel-control-next-icon"
                                            aria-hidden="true"
                                        ></span>
                                        <span class="sr-only">Next</span>
                                    </a>
                                </div>
                            </div>
                            <div class="card-footer">
                                <div class="form-group">
                                    <input
                                        type="file"
                                        class="form-control"
                                        ref="file"
                                        id="file"
                                        multiple
                                        @change="addFile"
                                    />
                                </div>
                                <div class="form-group">
                                    <button
                                        class="btn btn-primary"
                                        @click="addImages"
                                    >
                                        Add
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-7">
                        <div class="card card-danger card-outline">
                            <div class="card-header">Thumbnail Images</div>
                            <div class="card-body">
                                <div class="row">
                                    <div
                                        class="col-sm-2 mb-2"
                                        v-for="(image, index) in buyback_images"
                                        :key="index"
                                    >
                                        <img
                                            class="img-fluid"
                                            :src="image.url"
                                            alt="Buyback thumbnail"
                                            style="
                                                width: 20px;
                                                height: 20px;
                                                cursor: pointer;
                                            "
                                            @click="openImageModal(index)"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br /><br />
                        <div class="card card-danger card-outline">
                            <div class="card-header">Buyback Notes</div>
                            <div class="card-body">
                                <p v-for="(note, index) in buyback_notes">
                                    {{ index + 1 }}. {{ note.note }}
                                </p>
                            </div>
                            <div class="card-footer">
                                <div class="form-group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Add new buyback note"
                                        v-model="buyback_note"
                                    />
                                </div>
                                <div class="form-group">
                                    <button
                                        class="btn btn-primary"
                                        @click="addNote"
                                    >
                                        Add
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="modal fade bd-example-modal-lg"
                tabindex="-1"
                role="dialog"
                aria-labelledby="myLargeModalLabel"
                aria-hidden="true"
                id="disposedmodal"
            >
                <div class="modal-dialog modal-xl">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Dispose</h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group">
                                <label>Disposed For</label>
                                <input
                                    type="number"
                                    placeholder="Enter the disposed amount"
                                    class="form-control"
                                    min="1"
                                    v-model="disposed_for"
                                />
                            </div>
                            <div class="form-group">
                                <button
                                    class="btn btn-primary"
                                    @click="dispose"
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="modal fade bd-example-modal-lg"
                tabindex="-1"
                role="dialog"
                aria-labelledby="myLargeModalLabel"
                aria-hidden="true"
                id="imageModal"
            >
                <div class="modal-dialog modal-xl">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Image Preview</h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <img
                                id="modalImage"
                                class="img-fluid"
                                :src="selectedImage.url"
                                alt="Buyback image"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- /.content -->

        <!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
export default {
    mounted() {
        console.log("Component mounted.");
    },

    created() {
        this.getBuyback();
    },

    data() {
        return {
            buyback: {},
            buyback_notes: [],
            buyback_note: "",
            disposed_for: "",
            buyback_images: [],
            files: [],
            selectedImage: {},
        };
    },

    methods: {
        getBuyback() {
            axios
                .post("/api/getBuybackDetails", { id: this.$route.params.id })
                .then((response) => {
                    this.buyback = response.data;
                    this.buyback_notes = response.data.buyback_notes;
                    this.buyback_images = response.data.buyback_item_images;
                });
        },

        addNote() {
            axios
                .post("/api/addBuybackNote", {
                    id: this.buyback.id,
                    note: this.buyback_note,
                })
                .then(() => {
                    axios
                        .post("/api/getBuybackNotes", { id: this.buyback.id })
                        .then((response) => {
                            this.buyback_notes = response.data;
                        });
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed!",
                    });
                });
        },

        addFile() {
            this.files = [];
            let uploadedFiles = this.$refs.file.files;
            /*
							Adds the uploaded file to the files array
						*/
            for (var i = 0; i < uploadedFiles.length; i++) {
                let temp = {
                    file: uploadedFiles[i],
                    url: URL.createObjectURL(uploadedFiles[i]),
                };
                this.files.push(temp);
            }
        },

        openImageModal(index) {
            this.selectedImage = this.buyback_images[index];
            $("#imageModal").modal("show");
        },

        disposedForPrompt(id) {
            this.curr_id = id;
            $("#disposedmodal").modal("show");
        },

        dispose() {
            axios
                .post("/api/buybackDisposed", {
                    id: this.buyback.id,
                    disposed_for: this.disposed_for,
                })
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "Item Disposed",
                    });
                    this.getBuybacks(
                        "/api/getBuybackReport" +
                            "?page=" +
                            this.pagination.currentPage
                    );
                })
                .catch((errors) => {
                    toast.fire({
                        icon: "error",
                        title: "Failed! Please Check Input",
                    });
                });
        },

        addImages() {
            var formData = new FormData();
            formData.set("id", this.buyback.id);
            formData.set("imei", this.buyback.imei);
            formData.set("gatepass_id", this.buyback.gatepass_id);
            for (var i = 0; i < this.files.length; i++) {
                let file = this.files[i].file;
                //console.log(file);
                formData.append("files[" + i + "]", file);
            }
            axios({
                method: "post",
                url: "/api/addBuybackImages",
                data: formData,
                headers: { "Content-Type": "multipart/form-data" },
            })
                .then((response) => {
                    toast.fire({
                        icon: "success",
                        title: "Images Added",
                    });
                    axios
                        .post("/api/getBuybackImages", {
                            buyback: this.buyback.id,
                        })
                        .then((response) => {
                            this.buyback_images = response.data;
                        });
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed!",
                    });
                });
        },
    },
};
</script>
